<template>
  <div>
    <BaseButton success outline small class="w-full" @click="manageReviews">
      Manage Reviews
    </BaseButton>
  </div>
</template>

<script>
export default {
  props: {
    projectAssetId: {
      type: String,
      required: true,
    },
  },
  inject: ['refreshTask', 'getProjectAssets'],
  methods: {
    manageReviews() {
      const vm = this;
      this.$modal.show({
        component: () => import('Components/ProjectAssets/ManageReviewsModal.vue'),
        props: {
          projectAssetId: this.projectAssetId,
        },
        on: {
          change: () => {
            vm.refreshTask();
            vm.getProjectAssets();
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
